module.exports = __webpack_public_path__ + "img/LF005-06.5fc20486.jpg";